<!-- 巅峰赛事包 -->
<template>
  <div class='vipBag' :class="{'vipBagNoHeader':noHeader}">
    <publicHeader :pageTitle="pageTitle" v-if="!noHeader"></publicHeader>
    <div class="zhanwei" v-if="!noHeader">

    </div>
    <!-- 包名 -->
    <div class="bagName">
      {{cardInfo.vipName}}
    </div>
    <!-- 用户信息 -->
    <div class="userInfo">
      <!-- 头像 -->
      <div class="userHeadImg">
        <img :src="vipUserInfo.userHeadImg" v-if="vipUserInfo.userHeadImg">
      </div>
      <!-- 昵称 -->
      <div class="userName" v-if="vipUserInfo.userName">
        {{vipUserInfo.userName}}
      </div>
      <!-- 立即登录 -->
      <div class="userName" v-else @click="gotoLogin">
        立即登录
      </div>
      <!-- 状态 -->
      <div class="status" v-if="vipUserInfo.userName">
        {{vipUserInfo.vipDesc}}
      </div>
      <!-- 状态 -->
      <div class="status" v-else>
        登录后享受更多会员权益
      </div>
      <div>

      </div>
    </div>
    <!-- 包信息 -->
    <div class="bagInfo">
      <div class="leftInfo">
        <div class="name">{{cardInfo.vipName}}</div>
        <div class="time">{{cardInfo.payDesc}}</div>
      </div>
      <div class="rightInfo" :class="{'oneSty':!oldPrice}">
        <div class="nowPrice" v-if="nowPrice">
          <span>￥</span>{{nowPrice}}
        </div>
        <div class="oldPrice" v-if="oldPrice">
          <del>售价￥{{oldPrice}}</del>
        </div>
        <!-- <div class="nowPrice" v-if="item.dfPriceType==='1' && cardInfo.text.type===2"><span>￥</span>{{item.price}}</div>
        <div class="oldPrice" v-if="item.dfPriceType==='1' && cardInfo.text.type===1"><del>售价￥{{item.price}}</del></div>
      </div> -->

      </div>
      <div class="desc" v-if="cardInfo.text">
        {{cardInfo.text.priceName}}
      </div>
    </div>
    <!-- 会员权益 -->
    <div class="vipRights">
      <div class="title">会员权益</div>
      <div class="rightsBox">
        <div class="rightsItem" v-for="(item,index) in privilege" :key="index">
          <div class="itemIcon">
            <img :src="item.icon" alt="">
          </div>
          <div class="itemName">
            {{item.desc}}
          </div>
        </div>
      </div>
    </div>
    <!-- 活动说明 -->
    <div class="infomation">
      <div class="title">
        活动说明：
      </div>
      <div class="info" v-html="cardDesc">
      </div>
    </div>
    <!-- 底部价格栏 -->
    <div class="priceBigBox">
      <div class="priceBox">
        <div class="price" v-if="!isVip">
          <div class="numInfo">
            总计：<span>￥</span>
            <div class="num">{{nowPrice}}</div>
          </div>
          <div class="serve">
            <div class="word1">支付即同意</div>
            <div class="word2" @click="gotoVipPrivilege">会员服务协议></div>
          </div>
        </div>
        <div class="price blackPrice" v-else>
          <div class="numInfo">
            总计：<span>￥</span>
            <div class="num">{{nowPrice}}</div>
          </div>
          <div class="serve">
            <div class="word1">支付即同意</div>
            <div class="word2" @click="gotoVipPrivilege">会员服务协议></div>
          </div>
        </div>
        <div class="buyBtn" v-if="!isVip && vipUserInfo" @click="payDialogShow">
          立即购买
        </div>
        <div class="buyBtn black" v-if="isVip" @click="payedTips">
          已购买
        </div>
      </div>

    </div>
    <!-- 支付弹窗 -->
    <PublicPay :cardId="id" :payName="cardInfo.vipName" :payPrice="nowPrice" :payType="payType" @changePayShow="showPayDialog" :isShowDialog='isShowDialog' :priceId='payPriceId' v-show="isShowDialog &!isIOS"></PublicPay>
    <!-- 提示弹窗 -->
    <publicDialog :info="info" :title="title" :btn1="btn1" :btn2="btn2" @changeShow='showDialog' :dialogIsShow='dialogIsShow' v-show='dialogIsShow'></publicDialog>
  </div>
</template>

<script>
import PublicPay from '../components/PublicPay'
import publicHeader from '../components/PublicHeader'
import publicDialog from '../components/PublicDialog'

export default {
  components: {
    PublicPay, publicHeader, publicDialog
  },
  data () {
    return {
      id: '',
      type: '',
      isIOS: false,
      // 支付信息
      payName: '巅峰赛事包名称会员',
      payPrice: '6.00',
      payType: [5, 6, 2],
      priceId: '',
      isShowDialog: false,
      // 是否购买
      isVip: 0,
      // 用户信息
      userInfo: {
        userName: '因吹斯汀',
        userHeadImg: 'https://t100-file.zhibo.tv/uploads/imgs/2020/08-21/1597978714.jpg',
        status: 0
      },
      // 用户信息（接口返回）
      vipUserInfo: '',
      // 包信息（接口返回）
      cardInfo: '',
      // 价格信息（接口返回）
      vipCardPrice: '',
      // 描述信息
      cardDesc: '',
      // 会员权益（接口返回）
      privilege: '',
      pageTitle: '',
      token: '',
      // dialog的提示内容
      dialogIsShow: false,
      info: '',
      title: "",
      btn1: "",
      btn2: '我知道了',
      // 是否需要公共头
      noHeader: false
    }
  },
  created () {
    this.noHeader = this.$route.query.noHeader
    console.log(this.noHeader);
    this.getToken()
    this.isIOS = this.$CONFIG.isIOS
    this.id = this.$route.query.id
    this.type = this.$route.query.type

    this.getVipInfo()
  },
  mounted () {
    window.VIP_CENTER = {
      paySucc: () => {
        this.info = "您已成功购买会员"
        this.paySuccess = true
        this.showDialog(true)
      }
    }
  },
  computed: {
    // dfPriceType	0早鸟价 1正常价
    // type 1早鸟价 2正常价
    nowPrice: function () {
      let res = ''
      for (let i = 0;i < this.vipCardPrice.length;i++) {
        // 正常价
        if (this.vipCardPrice[i].dfPriceType === '1' && this.cardInfo.text.type === 2) {
          res = this.isIOS ? this.vipCardPrice[i].iosPrice : this.vipCardPrice[i].price
        }
        // 早鸟价
        if (this.vipCardPrice[i].dfPriceType === '0' && this.cardInfo.text.type === 1) {
          res = this.isIOS ? this.vipCardPrice[i].iosPrice : this.vipCardPrice[i].price
        }
      }
      return res
    },
    oldPrice: function () {
      let res = ''
      for (let i = 0;i < this.vipCardPrice.length;i++) {
        // 早鸟价时的售价（原价）
        if (this.vipCardPrice[i].dfPriceType === '1' && this.cardInfo.text.type === 1) {
          res = this.isIOS ? this.vipCardPrice[i].iosPrice : this.vipCardPrice[i].price
        }
      }
      return res
    },
    // ios支付productid
    productId: function () {
      let res = ''
      for (let i = 0;i < this.vipCardPrice.length;i++) {
        // 正常价
        if (this.vipCardPrice[i].dfPriceType === '1' && this.cardInfo.text.type === 2) {
          res = this.isIOS ? this.vipCardPrice[i].iosProductId : ''
        }
        // 早鸟价
        if (this.vipCardPrice[i].dfPriceType === '0' && this.cardInfo.text.type === 1) {
          res = this.isIOS ? this.vipCardPrice[i].newIosProductId : ''
        }
      }
      return res
    },
    payPriceId: function () {
      let res = ''
      for (let i = 0;i < this.vipCardPrice.length;i++) {
        // 正常价
        if (this.vipCardPrice[i].dfPriceType === '1' && this.cardInfo.text.type === 2) {
          res = this.isIOS ? '' : this.vipCardPrice[i].priceId
        }
        // 早鸟价
        if (this.vipCardPrice[i].dfPriceType === '0' && this.cardInfo.text.type === 1) {
          res = this.isIOS ? '' : this.vipCardPrice[i].priceId
        }
      }
      console.log(res);
      return res
    }
  },
  methods: {
    // 获取url上的信息
    getcommit (name) {
      return (
        decodeURIComponent(
          (new RegExp("[?|&]" + name + "=" + "([^&;]+?)(&|#|;|$)").exec(
            location.href
          ) || ["", ""])[1].replace(/\+/g, "%20")
        ) || false
      );
    },
    // 获取token
    getToken () {
      if (this.$CONFIG.isVerify && this.isIOS) {
        this.token = '2a9cc326033c71cd67ac7caba01c2cd0*8028670'
      } else {
        this.token = this.getcommit('token') || ''
      }
      console.log(this.token);
    },
    // 调支付
    gotoLogin () {
      this.phoneLogin()
    },
    // 两端的登录方法
    phoneLogin () {
      // 安卓登录
      try {
        window.LiveAppJS.login();
      } catch (e) {
        console.log('error')
      }
      // IOS登录
      try {
        window.webkit.messageHandlers.isnotlogin.postMessage('login');
      } catch (e) {
        console.log('error')
      }

    },
    // 获取会员卡信息
    getVipInfo () {
      let params = {
        token: this.token,
        type: this.type,
        id: this.id,
        statistics: this.$CONFIG.statistics
      }
      this.$vipapi.getVipInfo(params).then(res => {
        this.isVip = res.data.data.isVip
        // 用户信息
        this.vipUserInfo = res.data.data.vipUserInfo
        // 会员卡信息
        this.cardInfo = res.data.data.vipCardInfo
        document.title = this.cardInfo.vipName
        this.pageTitle = this.cardInfo.vipName
        // 会员卡描述，匹配换行
        this.cardDesc = res.data.data.vipCardInfo.text.desc.replace(/\n/g, '<br>')
        // 会员卡价格信息
        this.vipCardPrice = res.data.data.dfVipCardPrice
        this.priceId = this.vipCardPrice[0].priceId
        this.privilege = res.data.data.privilege.info
        this.shareInfo()
        this.changeAppTitle(this.pageTitle)
      })
    },
    // 苹果支付
    gotoIOSPay () {
      console.log(this.productId);
      try {
        window.webkit.messageHandlers.paymentWithProduct.postMessage({ 'productId': this.productId });
        return;
      } catch (error) {
        console.log('error');
      }
    },
    payDialogShow () {
      if (this.token) {
        if (this.isIOS) {
          this.gotoIOSPay()
        } else {
          console.log('已经登录');
          this.showPayDialog(true)
        }
      } else {
        this.phoneLogin()
      }
    },
    // 显示支付弹框
    showPayDialog (visible) {
      // this.isPaying=true
      this.isShowDialog = visible
    },
    // 已购买的弹窗提示
    payedTips () {
      this.title = '提示'
      this.info = '您已购买过巅峰赛事包，可能会延时到账，请耐心等待！'
      this.showDialog(true)
    },
    // 显示弹窗
    showDialog (visible) {
      this.dialogIsShow = visible
    },
    // 跳转会员服务协议
    gotoVipPrivilege () {
      // window.location.href = "http://vip.zhibo.tv/vip/privilege-explain"
      let url = 'http://vip.zhibo.tv/vip/privilege-explain?isApp=1'
      var androidParam = '{"url":"' + url + '"}';
      var iosParam = {
        "url": url
      };
      try {
        window.webkit.messageHandlers.jumpWeb.postMessage(iosParam);
      } catch (e) {
        console.log('ios打开新页面失败');
      }

      try {
        window.LiveAppJS.jumpWeb(androidParam);
      } catch (e) {
        console.log('安卓打开新页面失败');
      }
    },
    // 没有公共头时的分享
    shareInfo () {
      // let host = window.location.hostname;
      // let jumpUrl = "https://" + host + "/sparta/#/start?share=1";
      // let jumpUrl = location.href;
      let jumpUrl = `https://${this.convertDomain('static.zhibo.tv')}/shareshop/#/dfVip?id=${this.id}`;
      let imageUrl = "https://images.zhibo.tv/2021/0317/icon_df@3x.png",
        title = `加入${this.pageTitle}，围观精彩赛事`,
        desc = `加入${this.pageTitle}，围观精彩赛事`;
      let param = {
        title: title,
        des: desc,
        imageUrl: imageUrl,
        jumpUrl: jumpUrl
      };
      console.log(title, imageUrl, jumpUrl, param)
      try {
        window.webkit.messageHandlers.shareProduct.postMessage(param);
      } catch (e) {
        console.log("ios启用分享按钮");
      }
      try {
        window.LiveAppJS.shareProduct(title, desc, imageUrl, jumpUrl);
      } catch (e) {
        console.log("Android启用分享按钮");
      }
    },
    // 判断环境
    convertDomain (currDomain) {
      var localDomain = window.location.host
      var name = localDomain.split('.', 2)[0]
      var arr = name.split('-', 2)
      return arr.length > 1 ? arr[0] + '-' + currDomain : currDomain
    },
    // 修改两端标题
    changeAppTitle (newtitle) {
      try {
        window.webkit.messageHandlers.changeTitle.postMessage(newtitle)
      } catch (e) {
        console.log('IOS修改标题',newtitle)
      }
      try {
        window.LiveAppJS.changeTitle(newtitle)
      } catch (e) {
        console.log("安卓修改标题",newtitle)
      }
    }
  },
}
</script>
<style lang='less' scoped>
.vipBag {
  width: 100vw;
  min-height: 100vh;
  background: url('https://images.zhibo.tv/2020/1109/blackbg.png') #222224
    no-repeat 0 0.88rem ;
  background-size: 100%;
  // overflow: hidden;

  @font-face {
    font-family: BebasNeue;
    src: url('https://images.zhibo.tv/fonts/BebasNeue.eot');
    src: url('https://images.zhibo.tv/fonts/BebasNeue.eot')
        format('embedded-opentype'),
      url('https://images.zhibo.tv/fonts/BebasNeue.woff2') format('woff2'),
      url('https://images.zhibo.tv/fonts/BebasNeue.woff') format('woff'),
      url('https://images.zhibo.tv/fonts/BebasNeue.ttf') format('truetype'),
      url('https://images.zhibo.tv/fonts/BebasNeue.svg#BebasNeue') format('svg');
  }

  // 包名
  .bagName {
    padding: 1.5rem 0;
    text-align: center;
    font-size: 0.6rem;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: bolder;
    color: #c4a485;
    // text-shadow: 0.02rem 0.02rem 0 #5f3e2b;
    background: linear-gradient(
      119deg,
      #fdf0de 0%,
      #f8e1bf 25%,
      #f5d3a5 54%,
      #f5c295 100%
    );
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  // 用户信息
  .userInfo {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    // 头像
    .userHeadImg {
      width: 0.9rem;
      height: 0.9rem;
      margin-bottom: 0.2rem;
      border-radius: 50%;
      border: 0.04rem solid #e7c590;
      overflow: hidden;
      background: url('https://images.zhibo.tv/2020/1124/dfHeadIImg.png')
        no-repeat;
      background-size: 100%;
      img {
        display: block;
        width: 0.9rem;
        height: 0.9rem;
        // border-radius: 50%;

        // border-radius: 50%;
      }
    }

    // 昵称
    .userName {
      margin-bottom: 0.08rem;
      font-size: 0.32rem;
      font-family: PingFangSC-Light, PingFang SC;
      font-weight: 300;
      color: #f0dec8;
    }

    // 状态
    .status {
      margin-bottom: 0.5rem;
      font-size: 0.26rem;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #ffffff;
    }
  }

  // 包信息
  .bagInfo {
    width: 6.6rem;
    height: 2rem;
    padding: 0.53rem 0.57rem;
    box-sizing: border-box;
    margin: 0 auto;
    border-radius: 0.1rem;
    background: url('https://images.zhibo.tv/2020/1109/bagbg@2x.png') no-repeat;
    background-size: 100%;
    display: flex;
    justify-content: space-between;
    position: relative;

    // align-items: baseline;
    .leftInfo {
      display: flex;
      flex-direction: column;
      // justify-content: space-between;

      .name {
        height: 0.45rem;
        // background: chartreuse;
        margin-top: 0.06rem;
        margin-bottom: 0.1rem;
        font-size: 0.32rem;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: bold;
        color: #333333;
      }

      .time {
        height: 0.33rem;
        // background: cornflowerblue;
        font-size: 0.24rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #78482e;
      }
    }

    .rightInfo {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      position: relative;

      &::after {
        content: '';
        position: absolute;
        width: 0.14vw;
        height: 100%;
        // background: red;
        left: -0.3rem;
        border-left: 0.02rem dashed #2e2d32;
      }

      .nowPrice {
        height: 0.6rem;
        font-size: 0.6rem;
        font-family: BebasNeue;
        color: #333333;

        span {
          height: 0.28rem;
          display: inline-block;
          font-size: 0.28rem;
          line-height: 0.28rem;
          font-family: BebasNeue;
          color: #333333;
          // margin-bottom: 0.2rem;
        }
      }

      .oldPrice {
        white-space: nowrap;
        font-size: 0.24rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #78482e;
      }
    }
    .oneSty {
      justify-content: center;
    }
    // 右上角描述
    .desc {
      height: 0.37rem;
      position: absolute;
      right: 0;
      top: -0.05rem;
      padding:0.04rem 0.15rem 0 0.15rem;
      background: linear-gradient(
        135deg,
        #ff6777 0%,
        #fb7d54 47%,
        #ee4f46 100%
      );
      border-radius: 0.02rem 0.12rem 0.02rem 0.12rem;

      font-size: 0.24rem;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #ffffff;
      text-shadow: 0 0.02rem 0.04rem rgba(255, 0, 0, 0.5);
      display: flex;
      justify-content: center;
      align-items: center;
      line-height: 1;
    }
  }

  // 会员权益
  .vipRights {
    margin: 0 auto;
    margin-top: 0.6rem;

    .title {
      text-align: center;
      font-size: 0.32rem;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: bold;
      color: #f0dec8;
    }

    .rightsBox {
      width: 7rem;
      // height: 4.67rem;
      margin: 0 auto;
      margin-top: 0.45rem;
      margin-bottom: 0.6rem;
      // margin-bottom: 0.3rem;
      display: flex;
      flex-wrap: wrap;
      // background: #fcf9f5;
      // border-radius: 0.1rem;
      box-sizing: border-box;
      // padding: 0.48rem 0 0.3rem 0;
      .rightsItem {
        height: 1.38rem;
        margin-bottom: 0.28rem;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;

        flex-shrink: 0;
        width: calc(100% / 3);
        .itemIcon {
          width: 1rem;
          height: 1rem;
          margin-bottom: 0.04rem;
          img {
            display: block;
            width: 1rem;
            height: 1rem;
          }
        }
        .itemName {
          font-size: 0.24rem;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #fadeb9;
        }
      }
    }
  }

  // 活动说明
  .infomation {
    padding: 0 0.45rem 1.9rem 0.45rem;

    .title {
      margin-bottom: 0.1rem;
      font-size: 0.3rem;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: bold;
      color: #a6a39f;
    }

    .info {
      font-size: 0.28rem;
      font-family: PingFangSC-Light, PingFang SC;
      font-weight: 300;
      color: #a6a39f;
      line-height: 0.45rem;
    }
  }

  // 底部价格栏
  .priceBigBox {
    width: 100%;
    height: 1.5rem;
    background: #222224;
    padding-bottom: constant(safe-area-inset-bottom); //兼容IOS < 11.2
    padding-bottom: env(safe-area-inset-bottom); //兼容IOS > 11.2
    position: fixed;
    bottom: 0;
    left: 0;
    .priceBox {
      width: 100%;
      box-sizing: border-box;
      padding: 0.2rem 0.15rem 0.1rem 0.3rem;

      background: #222224;
      box-shadow: 0 -0.02rem 0 0 rgba(255, 255, 255, 0.1);
      display: flex;
      justify-content: space-between;

      .price {
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        .numInfo {
          display: flex;
          justify-content: flex-start;
          align-items: baseline;
          font-size: 0.28rem;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #e5e5e5;

          span {
            font-size: 0.28rem;
            font-family: BebasNeue;
            color: #d8bea4;
          }

          .num {
            font-size: 0.6rem;
            font-family: BebasNeue;
            color: #d8bea4;
          }
        }

        .serve {
          display: flex;
          margin-bottom: 0.1rem;

          .word1 {
            font-size: 0.24rem;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #e5e5e5;
          }

          .word2 {
            font-size: 0.24rem;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #d8bea4;
          }
        }
      }

      .blackPrice {
        .numInfo {
          color: #a6a39f;

          span {
            color: #a6a39f;
          }

          .num {
            color: #a6a39f;
          }
        }

        .serve {
          .word1 {
            color: #a6a39f;
          }

          .word2 {
            color: #a6a39f;
          }
        }
      }

      // 按钮
      .buyBtn {
        width: 3.4rem;
        height: 0.9rem;
        display: flex;
        justify-content: center;
        align-items: center;
        background: linear-gradient(
          120deg,
          #f3e7d8 0%,
          #ead4bc 54%,
          #f6e5c9 100%
        );
        border-radius: 0.45rem;

        font-size: 0.32rem;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: bold;
        color: #613f25;
      }

      .black {
        background: #a6a39f;
        color: rgba(255, 255, 255, 0.8);
      }
    }
  }
}
.vipBagNoHeader{
  width: 100vw;
  min-height: 100vh;
  background: url('https://images.zhibo.tv/2020/1109/blackbg.png') #222224
    no-repeat 0 top;
  background-size: 100%;
}
</style>